// src/data/requestDecisions.ts
// ----------------------------
// Repository for the Stage 1 DECISION LOG (db-207). The only write is the
// record_request_decisions() RPC — the table itself has no INSERT/UPDATE/DELETE
// privilege for app users, and decided_by is set server-side from auth.uid().
//
// BEST-EFFORT by design: this NEVER throws. Confirm & Send calls it last, after
// every critical step, so a logging failure can't block or undo an approval.

import type { DecisionRow } from "../services/decisionLog";
import type { Json } from "../types/database.generated";
import { logger } from "../utils/logger";
import { getTypedClient } from "../utils/supabase";

export type RecordDecisionsResult = { count: number; error: { message: string } | null };

export async function recordRequestDecisions(
  requestId: number | string,
  confirmedAt: string,
  rows: DecisionRow[]
): Promise<RecordDecisionsResult> {
  if (!Array.isArray(rows) || rows.length === 0) return { count: 0, error: null };
  const c = getTypedClient();
  if (!c) return { count: 0, error: null };
  try {
    const { data, error } = await c.rpc("record_request_decisions", {
      p_request_id: Number(requestId),
      p_confirmed_at: confirmedAt,
      p_rows: rows as unknown as Json,
    });
    if (error) {
      logger.warn("record_request_decisions failed:", error.message);
      return { count: 0, error };
    }
    return { count: typeof data === "number" ? data : 0, error: null };
  } catch (e) {
    logger.warn("record_request_decisions error:", e);
    return { count: 0, error: { message: String(e) } };
  }
}
